module.exports = {
  email: 'peternondo1@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/BUPE-NONDO',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/bupe-nondo-8497061b9/',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/bupe.king',
    },
    {
      name: 'X',
      url: 'https://x.com/Bupeofficial?t=0A1wTyImkarR2YnX4iQLEQ&s=08',
    },
    {
      name: 'Email',
      url: 'mailto:peternondo1@gmail.com',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    // {
    //   name: 'Experience',
    //   url: '/#jobs',
    // },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#e066ff',
    navy: '#2d1b4e',
    darkNavy: '#1a0d2e',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
